module.exports = __webpack_public_path__ + "static/media/twitter-icon.a5b676be.svg";